<template>
  <div class="demandReport" id="demandReport">
    <div class="leftDiv">
      <div class="leftTopDiv">
        <div class="userInfoClass">
          <div class="photo">
            <img v-if="userInfo.iconUrl" :src="userInfo.iconUrl" />
          </div>
          <div class="basicInfo">
            <tooltip-over
              :content="userInfo.username"
              :className="'username'"
              class="wid190"
              refName="username"
            ></tooltip-over>
            <div class="line"></div>
            <tooltip-over
              :content="'账号:' + userInfo.userNo"
              :className="'userNo'"
              class="wid190"
              refName="userNo"
            ></tooltip-over>
            <tooltip-over
              :content="userInfo.departmentName"
              :className="'departmentName'"
              class="wid190"
              refName="departmentName"
            ></tooltip-over>
            <tooltip-over
              :content="userInfo.roleName"
              :className="'roleName'"
              class="wid190"
              refName="roleName"
            ></tooltip-over>
          </div>
          <div class="logOut" @click="logOut()"></div>
        </div>
        <div class="statistics">
          <div
            class="waitApproval"
            :style="opacityOfWaitApproval"
            @click="waitApproval"
          >
            <div class="title">待审批</div>
            <div class="num">{{ waitApprovalNum }}</div>
          </div>
          <div
            class="approvaled"
            :style="opacityOfApprovaled"
            @click="approvaled"
          >
            <div class="title">已通过</div>
            <div class="num">{{ approvaledNum }}</div>
          </div>
          <div class="rejected" :style="opacityOfRejected" @click="rejected">
            <div class="title">驳回</div>
            <div class="num">{{ rejectedNum }}</div>
          </div>
        </div>
      </div>
      <div class="leftBottomDiv">
        <div class="contentClass">
          <div>
            <el-table
              :data="taskList"
              @row-click="clickTaskRow"
              ref="taskList"
              height="384"
              :row-style="{ height: '40px' }"
              :cell-style="changeCellStyle"
              :row-class-name="tableRowClassName"
              style="width: 92%"
              tooltip-effect="light"
              class="taskTable"
            >
              <el-table-column
                prop="local_id"
                label="任务编号"
                min-width="80"
                :show-overflow-tooltip="true"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="mission_name"
                label="任务名称"
                align="center"
                min-width="100"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                prop="priority"
                label="优先级"
                align="center"
                min-width="60"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.priority === 1">低</span>
                  <span v-else-if="scope.row.priority === 2">中</span>
                  <span v-else-if="scope.row.priority === 3">高</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="mission_status"
                label="当前状态"
                align="center"
                min-width="60"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.mission_status === 5">待审批</span>
                  <span v-else-if="scope.row.mission_status === 8">驳回</span>
                  <span v-else-if="scope.row.mission_status === 10"
                    >待取货</span
                  >
                  <span v-else-if="scope.row.mission_status === 20"
                    >完成取货</span
                  >
                  <span v-else-if="scope.row.mission_status === 90"
                    >任务完成</span
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="searchArea">
            <div class="desc">任务搜索</div>
            <div class="separate"></div>
            <el-form :model="queryTaskForm" @submit.native.prevent>
              <el-form-item label="">
                <el-input
                  class="inputClass"
                  v-model="queryTaskForm.key"
                  @keyup.enter.native="queryTask()"
                >
                  <i
                    class="el-icon-search-img"
                    slot="suffix"
                    @click="queryTask()"
                  >
                  </i></el-input
              ></el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div class="centerDiv" v-show="clickButton">
      <div class="formTitle">
        <div class="taskIcon">
          <el-image :src="taskIcon" class="icon" />
        </div>
        <div class="taskInfo">
          <div class="descOfNo">任务编号</div>
          <div class="line"></div>
          <tooltip-over
            :content="taskForm.local_id"
            :className="'taskNo'"
            class="wid190"
            refName="taskNo"
          ></tooltip-over>
        </div>
        <div class="barCodeDiv">
          <img id="barCode" class="barCode" />
        </div>
      </div>
      <div class="seperate"></div>
      <div class="taskCreateInfo">
        <div class="label">创建时间:</div>
        <div class="content">{{ taskForm.created_at }}</div>
        <div class="label">提交账号:</div>
        <div class="content">{{ taskForm.user_no }}</div>
      </div>
      <div class="seperate"></div>
      <div class="formTaskDetail">
        <el-form ref="taskForm" :model="taskForm">
          <div class="firstRow">
            <el-form-item label="任务名称">
              <el-input
                class="formInputClass"
                maxlength="200"
                v-model="taskForm.mission_name"
                disabled
              >
              </el-input
            ></el-form-item>
            <div class="right">
              <el-form-item label="优先级">
                <div class="priorityDiv">
                  <img :src="minimum" class="minimum" />
                  <div class="prioritySeperate"></div>
                  <img :src="secondary" class="secondary" />
                  <div class="prioritySeperate"></div>
                  <img :src="highest" class="highest" />
                </div>
              </el-form-item>
            </div>
          </div>
          <div class="row">
            <el-form-item label="预计发货时间">
              <el-date-picker
                popper-class="datePickerClass"
                class="formInputClass"
                :picker-options="pickerOptions"
                v-model="taskForm.appointment_delivery_at"
                type="datetime"
                disabled
              >
              </el-date-picker>
            </el-form-item>
            <div class="right">
              <el-form-item label="预计收货时间">
                <el-date-picker
                  popper-class="datePickerClass"
                  class="formInputClass"
                  :picker-options="pickerOptions"
                  v-model="taskForm.appointment_receive_at"
                  type="datetime"
                  disabled
                >
                </el-date-picker>
              </el-form-item>
            </div>
          </div>
          <div class="sendUserInfo" style="background: #0083fd">
            <div class="descOfSendUser">投送信息（发送方）</div>
            <div class="addressInfo">
              <div
                :class="customerAddressShowClassName"
                @click="changeDetailShow(1)"
              ></div>
            </div>
          </div>
          <div class="rowAddress" v-show="customerAddressShow">
            <el-form-item label="补堆名称">
              <tooltip-over
                :content="taskForm.customer_company"
                :className="'formThreeClass'"
                class="wid190"
                refName="customer_company"
              ></tooltip-over>
            </el-form-item>
            <el-form-item label="联系人">
              <tooltip-over
                :content="taskForm.customer_name"
                :className="'formThreeClass'"
                class="wid190"
                refName="customer_name"
              ></tooltip-over
            ></el-form-item>
            <div class="right">
              <el-form-item label="联系电话">
                <tooltip-over
                  :content="taskForm.customer_phone"
                  :className="'formThreeClass'"
                  class="wid190"
                  refName="customer_phone"
                ></tooltip-over>
              </el-form-item>
            </div>
          </div>
          <div class="row" v-show="customerAddressShow">
            <el-form-item label="发货战区">
              <tooltip-over
                :content="taskForm.station_name"
                :className="'formTwoClass'"
                class="wid190"
                refName="station_name"
              ></tooltip-over>
            </el-form-item>
            <div class="right">
              <el-form-item label="发货地址">
                <tooltip-over
                  :content="taskForm.customer_address"
                  :className="'formTwoClass'"
                  class="wid190"
                  refName="customer_address"
                ></tooltip-over>
              </el-form-item>
            </div>
          </div>
          <div class="sendUserInfo" style="background: #ffa63e">
            <div class="descOfSendUser">投送信息（接收方）</div>
            <div class="addressInfo">
              <div
                :class="destinationAddressShowClassName"
                @click="changeDetailShow(2)"
              ></div>
            </div>
          </div>
          <div class="rowAddress" v-show="destinationAddressShow">
            <el-form-item label="补堆名称">
              <tooltip-over
                :content="taskForm.destination_company"
                :className="'formTwoClass'"
                class="wid190"
                refName="destination_company"
              ></tooltip-over>
            </el-form-item>
            <div class="right">
              <el-form-item label="收货地址">
                <tooltip-over
                  :content="taskForm.destination_address"
                  :className="'formTwoClass'"
                  class="wid190"
                  refName="destination_address"
                ></tooltip-over
              ></el-form-item>
            </div>
          </div>
          <div class="row" v-show="destinationAddressShow">
            <el-form-item label="联系人">
              <tooltip-over
                :content="taskForm.destination_name"
                :className="'formTwoClass'"
                class="wid190"
                refName="destination_name"
              ></tooltip-over>
            </el-form-item>
            <div class="right">
              <el-form-item label="联系电话">
                <tooltip-over
                  :content="taskForm.destination_phone"
                  :className="'formTwoClass'"
                  class="wid190"
                  refName="destination_phone"
                ></tooltip-over>
              </el-form-item>
            </div>
          </div>
          <div class="sendUserInfo" style="background: #0083fd">
            <el-checkbox
              v-model="taskForm.needTakeDelivery"
              disabled
              class="descOfSendUser"
              >是否需要取货</el-checkbox
            >
            <div class="addressInfo" v-show="taskForm.needTakeDelivery">
              <div
                :class="ifNeedPickUpInfoShowClassName"
                @click="changeDetailShow(3)"
              ></div>
            </div>
          </div>
          <div class="rowAddress" v-show="ifNeedPickUpInfoShow">
            <el-form-item label="指派货勤">
              <el-select
                v-model="taskForm.receiver_id"
                popper-class="selectPopperClass"
                disabled
              >
                <el-option
                  v-for="user in users"
                  :key="user.id"
                  :label="user.username"
                  :value="user.id"
                />
              </el-select>
            </el-form-item>
            <div class="right">
              <el-form-item label="联系电话">
                <el-input
                  class="formInputClass"
                  v-model="taskForm.receiverPhone"
                  disabled
                >
                </el-input
              ></el-form-item>
            </div>
          </div>
          <div class="row" v-show="ifNeedPickUpInfoShow">
            <el-form-item label="取货时间">
              <el-date-picker
                popper-class="datePickerClass"
                class="formInputClass"
                :picker-options="pickerOptions"
                v-model="taskForm.plan_receiver_at"
                type="datetime"
                disabled
              >
              </el-date-picker
            ></el-form-item>
          </div>
          <div class="sendUserInfo" style="background: #ffa63e">
            <div class="descOfSendUser">审批员</div>
            <div class="addressInfo">
              <div
                :class="auditInfoShowClassName"
                @click="changeDetailShow(4)"
              ></div>
            </div>
          </div>
          <div class="rowAddress" v-show="auditInfoShow">
            <el-form-item label="部门">
              <el-select
                v-model="taskForm.approve_user_department_id"
                popper-class="selectPopperClass"
                disabled
              >
                <el-option
                  v-for="department in departments"
                  :key="department.id"
                  :label="department.name"
                  :value="department.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="姓名">
              <el-select
                v-model="taskForm.approve_user_id"
                popper-class="selectPopperClass"
                disabled
              >
                <el-option
                  v-for="user in usersOfApprove"
                  :key="user.id"
                  :label="user.username"
                  :value="user.id"
                />
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
    <div class="rightDiv" v-show="clickButton" id="approval">
      <div class="rightTopDiv">
        <div class="rightMainContainer">
          <div class="rightCommonTitle">
            <div class="title">
              <i class="header-icon el-icon-goods-plan"></i>
              &nbsp;货物列表
            </div>
            <div class="title">货物名称:&nbsp;&nbsp;{{ goodsName }}</div>
          </div>
          <el-table
            :data="goodsList"
            class="goodsList"
            ref="goodsList"
            :height="goodsListHeight"
            :row-style="{ height: '40px' }"
            :cell-style="changeCellStyle"
            :row-class-name="goodsListRowClassName"
            tooltip-effect="light"
          >
            <el-table-column
              label="序号"
              align="center"
              prop="index"
              min-width="60"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              prop="local_id"
              label="货物编号"
              align="center"
              min-width="150"
              :show-overflow-tooltip="true"
            >
            </el-table-column
            ><el-table-column
              label="体积（长*宽*高）/cm"
              align="center"
              min-width="180"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span>
                  {{ scope.row.goods_length }}* {{ scope.row.goods_width }}*
                  {{ scope.row.goods_height }}
                </span>
              </template></el-table-column
            ><el-table-column
              label="重量/kg"
              align="center"
              min-width="80"
              prop="goods_weight"
              :show-overflow-tooltip="true"
            ></el-table-column
            ><el-table-column
              label="属性"
              min-width="220"
              align="center"
              prop="attributes"
              :show-overflow-tooltip="true"
            ></el-table-column
            ><el-table-column
              label="类型"
              align="center"
              prop="goods_type_name"
              min-width="80"
              :show-overflow-tooltip="true"
            ></el-table-column
            ><el-table-column
              label="包装"
              align="center"
              min-width="100"
              prop="goods_package_name"
              :show-overflow-tooltip="true"
            ></el-table-column
            ><el-table-column
              label="密级"
              align="center"
              min-width="60"
              prop="goods_secrecy_id"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.goods_secrecy_id === 0">非&nbsp;密</span>
                <span v-else-if="scope.row.goods_secrecy_id === 1"
                  >秘&nbsp;密</span
                >
                <span v-else-if="scope.row.goods_secrecy_id === 2"
                  >机&nbsp;密</span
                ><span v-else-if="scope.row.goods_secrecy_id === 3"
                  >绝&nbsp;密</span
                >
              </template></el-table-column
            >
          </el-table>
        </div>
      </div>
      <div class="rightCenterDiv" :style="rightCenterDivHight">
        <div class="historyButton">
          <div
            v-if="canEdit"
            :class="!isHistory ? 'remarkClassNow' : 'remarkClassHistory'"
            @click="isHistory = false"
          >
            新增备注
          </div>
          <div
            :class="isHistory ? 'remarkClassNow' : 'remarkClassHistory'"
            @click="isHistory = true"
          >
            历史备注
          </div>
        </div>
        <div v-if="isHistory">
          <div class="historyRemark" :style="historyRemarkHeight">
            <span v-for="(item, index) in taskForm.historyNote" :key="index">
              {{ item }}<br />
            </span>
          </div>
        </div>
        <div v-else-if="canEdit">
          <el-input
            style="height: 150px"
            maxlength="500"
            placeholder="请输入备注(500字内，且不能输入$)"
            @input="change($event)"
            type="textarea"
            v-model="taskForm.note"
          ></el-input>
        </div>
      </div>
      <div class="rightBottomDiv" v-if="canEdit">
        <el-button class="saveButton" @click="adopt()"> 通过</el-button>
        <el-button class="rejectButton" @click="reject()"> 驳回</el-button>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import tooltipOver from "../tools/tooltipOver";
import taskIcon from "../../assets/img/home/task.png";
import minimum from "../../assets/img/home/minimum.png";
import minimumUnchecked from "../../assets/img/home/minimumUnchecked.png";
import secondary from "../../assets/img/home/secondary.png";
import secondaryUnchecked from "../../assets/img/home/secondaryUnchecked.png";
import highest from "../../assets/img/home/highest.png";
import highestUnchecked from "../../assets/img/home/highestUnchecked.png";

export default {
  name: "DemandApproval",
  props: ["userInfo", "menuId"],
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      waitApprovalNum: 0,
      approvaledNum: 0,
      rejectedNum: 0,
      openTab: "waitApproval",
      opacityOfWaitApproval: "opacity: 1;",
      opacityOfApprovaled: "opacity: 0.4;",
      opacityOfRejected: "opacity: 0.4;",
      queryTaskForm: {
        approveStatus: 0, //审批状态,0为待审批,1为审批通过,-1已驳回
        currentpage: 1,
        pagesize: 0,
        key: "",
      },
      taskList: [], //任务列表
      clickButton: false,
      openedId: null, //已展开的任务
      canEdit: false,
      taskForm: {
        id: "",
        local_id: "0000000-0000",
        user_no: "",
        mission_name: "",
        priority: "",
        customer_company: "",
        customer_name: "",
        customer_phone: "",
        customer_address: "",
        area_id: "",
        station_id: "",
        station_name: "",

        destination_company: "",
        destination_name: "",
        destination_phone: "",
        destination_address: "",

        appointment_delivery_at: "",
        appointment_receive_at: "",
        needTakeDelivery: true,
        need_take_delivery: "0",

        receiver_id: "",
        receiverPhone: "",

        approve_user_department_id: "",
        approve_user_id: "",

        plan_receiver_at: "",
        mission_status: "",
        historyNote: "",
        note: "",
        user_id: "",
        created_at: "",
        is_removed: 0,
      },
      taskIcon: taskIcon,
      minimum: minimumUnchecked,
      secondary: secondaryUnchecked,
      highest: highestUnchecked,
      customerAddressShowClassName: "downArrow",
      customerAddressShow: true,
      destinationAddressShowClassName: "downArrow",
      destinationAddressShow: true,
      ifNeedPickUpInfoShowClassName: "downArrow",
      ifNeedPickUpInfoShow: true,

      auditInfoShowClassName: "downArrow",
      auditInfoShow: true,
      users: [], //地面保障员
      roleName: "地面保障员",
      stations: [], //战区
      departments: [], //部门
      roleNameOfApprove: "态势监控员", //审批员角色名称
      usersOfApprove: [], //审批员

      goodsName: "", //货物名称
      goodsList: [], //货物列表信息
      goodsListHeight: 435,

      isHistory: false,
      replaceStr: "$", //分隔符

      rightCenterDivHight: "height: 202px;",
      historyRemarkHeight: "height: 160px;",
    };
  },
  methods: {
    change(e) {
      this.$forceUpdate();
      // 限制输入特殊字符$
      this.taskForm.note = e.replace(this.replaceStr, "");
    },
    waitApproval() {
      if (this.openTab !== "waitApproval") {
        this.opacityOfWaitApproval = "opacity: 1;";
        this.opacityOfApprovaled = "opacity: 0.4;";
        this.opacityOfRejected = "opacity: 0.4;";
        this.openedId = null;
        this.clickButton = false;
        this.queryTaskForm.approveStatus = 0;
        this.queryTask();
      }
      this.openTab = "waitApproval";
    },
    approvaled() {
      if (this.openTab !== "approvaled") {
        this.opacityOfWaitApproval = "opacity: 0.4;";
        this.opacityOfApprovaled = "opacity: 1;";
        this.opacityOfRejected = "opacity: 0.4;";
        this.openedId = null;
        this.clickButton = false;
        this.queryTaskForm.approveStatus = 1;
        this.queryTask();
      }
      this.openTab = "approvaled";
    },
    rejected() {
      if (this.openTab !== "rejected") {
        this.opacityOfWaitApproval = "opacity: 0.4;";
        this.opacityOfApprovaled = "opacity: 0.4;";
        this.opacityOfRejected = "opacity: 1;";
        this.openedId = null;
        this.clickButton = false;
        this.queryTaskForm.approveStatus = -1;
        this.queryTask();
      }
      this.openTab = "rejected";
    },
    // 数据统计
    getApproveMissionCount() {
      this.getRequest(
        "/uav-task-server/mission/getApproveMissionCount.do"
      ).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          let data = oData.data;
          if (data) {
            this.waitApprovalNum = data.waitingApprove;
            this.approvaledNum = data.passApprove;
            this.rejectedNum = data.rejectApprove;
          } else {
            this.waitApprovalNum = 0;
            this.approvaledNum = 0;
            this.rejectedNum = 0;
          }
        } else if (oData.code != 401) {
          let msg = "<i class='el-icon-warn-tip'></i>啊哦,任务统计失败~";
          this.$confirm(msg, "提示", {
            confirmButtonText: "好的",
            customClass: "confirmClass-style",
            iconClass: "",
            confirmButtonClass: "confirm",
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
          });
        }
      });
    },
    // 列表查询
    queryTask() {
      const params = this.getQueryParam(this.queryTaskForm);
      this.getRequest(
        "/uav-task-server/mission/getMissionApproveList.do?" + params
      ).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          let data = oData.data;
          if (data) {
            this.taskList = data.list;
          }
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>啊哦,任务列表获取失败~";
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "confirmClass-style",
            iconClass: "",
            confirmButtonClass: "confirm",
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
          });
        }
      });
    },
    changeCellStyle(row, column, rowIndex, columnIndex) {
      if (row.column.label === "优先级") {
        return "color:#FFA63E;padding: 0;"; //修改的样式
      } else {
        return "color:#FFFFFF;padding: 0;";
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (this.openedId === row.id) {
        return "focusRowStyle";
      }
      return "rowStyle";
    },
    clickTaskRow(row) {
      this.openedId = row.id;
      this.$refs.taskList.toggleRowSelection(row);
      let mission_status = row.mission_status;
      if (mission_status && mission_status === 5) {
        this.rightCenterDivHight = "height: 202px;";
        this.historyRemarkHeight = "height: 160px;";
        this.isHistory = false;
        this.canEdit = true;
      } else {
        this.rightCenterDivHight = "height: 261px;";
        this.historyRemarkHeight = "height: 222px;";
        this.isHistory = true;
        this.canEdit = false;
      }
      // this.getStations();
      this.queryDepartment();
      this.clickButton = true;
      this.$nextTick(() => {
        this.getMissionById(row.id);
      });
    },
    // 获取任务详情
    getMissionById(id) {
      this.postJsonRequest("/uav-task-server/mission/getMissionById.do", {
        id,
      }).then((res) => {
        let oData = res.data;
        if (oData.code === 0) {
          this.taskForm = oData.data;

          let note = this.taskForm.note;
          if (note) {
            let notes = note.split(this.replaceStr);
            if (notes && notes.length > 0) {
              let notee = [];
              notes.forEach((item) => {
                if (item) {
                  notee.push(item);
                }
              });
              this.taskForm.historyNote = notee;
            } else {
              this.taskForm.historyNote = "";
            }
          } else {
            this.taskForm.historyNote = "";
          }
          this.$set(this.taskForm, "note", "");
          this.choosePriority();
          this.dealDataAfterGetDetail();
          let approve_user_department_id = this.taskForm
            .approve_user_department_id;
          if (approve_user_department_id) {
            this.getUsers(
              2,
              this.roleNameOfApprove,
              approve_user_department_id
            );
          }
          let area_id = this.taskForm.area_id;
          let station_id = this.taskForm.station_id;
          this.setStationAndArea(area_id, station_id);
          this.createCode(this.taskForm.local_id);
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>" + oData.msg;
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "confirmClass-style",
            iconClass: "",
            confirmButtonClass: "confirm",
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
          });
        }
      });
    },
    // 获取站点信息
    getStations() {
      this.getRequest(
        "/basic-info-server/station/getStationGroupByArea.do"
      ).then((res) => {
        let oData = res.data;
        if (0 === oData.code) {
          let data = oData.data;

          if (!this.isEmptyArray(data)) {
            this.stations = this.resetStation(data);
          } else {
            this.stations = [];
          }
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>啊哦,获取战区失败~";
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "confirmClass-style",
            iconClass: "",
            confirmButtonClass: "confirm",
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
          });
        }
      });
    },
    resetStation(data) {
      if (!this.isEmptyArray(data)) {
        data.forEach((element) => {
          if (!this.isEmptyArray(element.children)) {
            element.children.forEach((e) => {
              e.id = e.id;
              e.value = e.name;
            });
          }
        });
      }
      return data;
    },
    // 获取用户信息
    getUsers(type, roleName, departmentId) {
      this.postJsonRequest(
        "/user-server/api/u-user/queryByDepartmentIdAndRoleName",
        {
          roleName,
          departmentId,
          removed: 0,
        }
      ).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          if (type === 1) {
            let users = oData.data;
            this.users = users;
            // 设置货物列表信息 end
            // 设置指派货勤信息
            if (users && users.length > 0) {
              let receiver_id = this.taskForm.receiver_id;
              if (receiver_id) {
                this.changeUser(receiver_id);
              }
            }
          } else if (type === 2) {
            this.usersOfApprove = oData.data;
          }
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>啊哦,用户获取失败~";
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "confirmClass-style",
            iconClass: "",
            confirmButtonClass: "confirm",
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
          });
        }
      });
    },
    // 获取部门信息
    queryDepartment() {
      this.postJsonRequest("/user-server/api/u-department/query?size=-1", {removed: 0})
        .then((res) => {
          res = res.data;
          if (null != res && !this.isEmptyArray(res.data.records)) {
            if (null != res.data) {
              this.departments = res.data.records;
            } else {
              this.departments = [];
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // this.confirmMessage(false, msg);
          }
        })
        .catch((error) => {});
    },
    // 设置优先级图标
    choosePriority() {
      let priority = this.taskForm.priority;
      if (1 === priority) {
        this.minimum = minimum;
        this.secondary = secondaryUnchecked;
        this.highest = highestUnchecked;
      } else if (2 === priority) {
        this.minimum = minimumUnchecked;
        this.secondary = secondary;
        this.highest = highestUnchecked;
      } else if (3 === priority) {
        this.minimum = minimumUnchecked;
        this.secondary = secondaryUnchecked;
        this.highest = highest;
      } else {
        this.minimum = minimumUnchecked;
        this.secondary = secondaryUnchecked;
        this.highest = highestUnchecked;
      }
    },
    // 获取详情后 数据处理
    dealDataAfterGetDetail() {
      let needTakeDelivery = this.taskForm.need_take_delivery;
      if (needTakeDelivery && 1 === Number(needTakeDelivery)) {
        this.$set(this.taskForm, "needTakeDelivery", true);
      } else {
        this.$set(this.taskForm, "needTakeDelivery", false);
      }
      this.changePickUp();
      // 设置货物列表信息 start
      let goodsList = this.taskForm.goods;
      if (goodsList && goodsList.length > 0) {
        let _this = this;
        _this.goodsName = goodsList[0].goods_name;
        goodsList.forEach(function (goods, index) {
          let attributes = [];
          let goods_attribute_id = goods.goods_attribute_id;
          if (goods_attribute_id && 1 === Number(goods_attribute_id)) {
            attributes.push("易碎性");
          }
          let goods_explosible_id = goods.goods_explosible_id;
          if (goods_explosible_id && 1 === Number(goods_explosible_id)) {
            attributes.push("易爆性");
          }
          let goods_inflammable_id = goods.goods_inflammable_id;
          if (goods_inflammable_id && 1 === Number(goods_inflammable_id)) {
            attributes.push("易燃性");
          }
          let goods_cautery_id = goods.goods_cautery_id;
          if (goods_cautery_id && 1 === Number(goods_cautery_id)) {
            attributes.push("腐蚀性");
          }
          let attributesStr = "";
          for (let i = 0, len = attributes.length; i < len; i++) {
            if (i === len - 1) {
              attributesStr += attributes[i];
            } else {
              attributesStr += attributes[i] + ",";
            }
          }
          _this.$set(goods, "attributes", attributesStr); //触发更新视图
        });
        _this.goodsList = goodsList;
      } else {
        this.goodsList = [];
      }
    },
    //设置指派获取电话号码
    changeUser(id) {
      if (id) {
        let user = {};
        user = this.users.find((item) => {
          return item.id === id;
        });
        if (user) {
          this.taskForm.receiverPhone = user.phone;
        } else {
          this.taskForm.receiverPhone = "";
        }
      } else {
        this.taskForm.receiverPhone = "";
      }
    },
    // 设置是否取货复选框信息
    changePickUp() {
      let needTakeDelivery = this.taskForm.needTakeDelivery;
      if (!needTakeDelivery) {
        this.ifNeedPickUpInfoShow = false;
      } else {
        this.ifNeedPickUpInfoShow = true;
        this.getUsers(1, this.roleName, this.userInfo.departmentId);
      }
      if (this.ifNeedPickUpInfoShow) {
        this.ifNeedPickUpInfoShowClassName = "downArrow";
      } else {
        this.ifNeedPickUpInfoShowClassName = "downArrowAfter";
      }
    },
    // 设置发货战区
    setStationAndArea(area_id, station_id) {
      if (area_id && station_id) {
        let area_name = "";
        let station_name = "";
        let stations = this.stations;
        if (stations && stations.length > 0) {
          for (let i = 0, len = stations.length; i < len; i++) {
            let station = stations[i];
            if (station && area_id === station.id) {
              area_name = station.value;
              let children = station.children;
              if (children && children.length > 0) {
                for (let j = 0, lenC = children.length; j < lenC; j++) {
                  let child = children[j];
                  if (child && station_id === child.id) {
                    station_name = child.value;
                    break;
                  }
                }
              }
              break;
            }
          }
        }
        this.taskForm.station_name = area_name + "/" + station_name;
      } else {
        this.taskForm.station_name = "";
      }
    },
    // 生成条形码
    createCode(localId) {
      JsBarcode("#barCode", localId, {
        format: "CODE39", //条形码的格式
        lineColor: "#ffffff", //线条颜色
        width: 1, //线宽
        height: 25, //条码高度
        displayValue: true, //是否在条形码下方显示文字
        background: "transparent", //背景色
        font: "ArialMT", //设置文本的字体
        textMargin: 5, //设置条形码和文本之间的间距
        fontSize: "12", //设置文本的大小
        margin: 10, //设置条形码周围的空白边距
      });
    },
    changeDetailShow(val) {
      if (1 === val) {
        this.customerAddressShow = !this.customerAddressShow;
        if (this.customerAddressShow) {
          this.customerAddressShowClassName = "downArrow";
        } else {
          this.customerAddressShowClassName = "downArrowAfter";
        }
      } else if (2 === val) {
        this.destinationAddressShow = !this.destinationAddressShow;
        if (this.destinationAddressShow) {
          this.destinationAddressShowClassName = "downArrow";
        } else {
          this.destinationAddressShowClassName = "downArrowAfter";
        }
      } else if (3 === val) {
        this.ifNeedPickUpInfoShow = !this.ifNeedPickUpInfoShow;
        if (this.ifNeedPickUpInfoShow) {
          this.ifNeedPickUpInfoShowClassName = "downArrow";
        } else {
          this.ifNeedPickUpInfoShowClassName = "downArrowAfter";
        }
      } else if (4 === val) {
        this.auditInfoShow = !this.auditInfoShow;
        if (this.auditInfoShow) {
          this.auditInfoShowClassName = "downArrow";
        } else {
          this.auditInfoShowClassName = "downArrowAfter";
        }
      }
    },
    goodsListRowClassName({ row, rowIndex }) {
      row.index = rowIndex + 1;
      return "rowStyle";
    },
    adopt() {
      let params = {
        missionId: this.taskForm.id,
        approveStatus: 1,
        note: this.taskForm.note,
      };
      this.approveMission(params);
    },
    reject() {
      let note = this.taskForm.note;
      if (note) {
        let params = {
          missionId: this.taskForm.id,
          approveStatus: -1,
          note,
        };
        this.approveMission(params);
      } else {
        let tips = "<i class='el-icon-warn-tip'></i>驳回时,需要填写备注哦~";
        this.$confirm(tips, "", {
          confirmButtonText: "好的",
          customClass: "confirmClass-style",
          iconClass: "",
          confirmButtonClass: "confirm",
          dangerouslyUseHTMLString: true,
          showCancelButton: false,
        });
      }
    },
    // 提交任务 审批结果,1为通过，-1为拒绝
    approveMission(params) {
      let tips = "<i class='el-icon-warn-tip'></i>确定提交该任务?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "confirmClass-style",
        iconClass: "",
        confirmButtonClass: "confirm",
        dangerouslyUseHTMLString: true,
        cancelButtonClass: "cancel",
      })
        .then(() => {
          params = this.getQueryParam(params);
          this.postJsonRequest(
            "/uav-task-server/mission/approveMission.do?" + params,
            {}
          ).then((res) => {
            let oData = res.data;
            if (oData.code == 0) {
              this.openedId = null;
              this.clickButton = false;
              this.getApproveMissionCount();
              this.queryTask();
              this.$message({
                message: "提交成功",
                duration: 1000,
                customClass: "message-s",
                iconClass: "el-icon-ok-tip",
                offset: 470,
                onClose: function () {},
              });
            } else if (oData.code != 401) {
              let msg = "<i class='el-icon-warn-tip'></i>啊哦,任务统计失败~";
              this.$confirm(msg, "提示", {
                confirmButtonText: "好的",
                customClass: "confirmClass-style",
                iconClass: "",
                confirmButtonClass: "confirm",
                dangerouslyUseHTMLString: true,
                showCancelButton: false,
              });
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  components: {
    "tooltip-over": tooltipOver,
  },
  mounted() {
    this.getApproveMissionCount();
    this.$nextTick(function () {
      this.queryTask();
    });
    window.statisicsTimer = setInterval(this.getApproveMissionCount, 28000); //28秒轮询一次
    window.queryTimer = setInterval(this.queryTask, 30000); //30秒轮询一次
  },
  beforeDestroy() {
    if (window.statisicsTimer) {
      clearInterval(window.statisicsTimer);
      window.statisicsTimer = null;
    }
    if (window.queryTimer) {
      clearInterval(window.queryTimer);
      window.queryTimer = null;
    }
  },
};
</script>

<style scoped>
@import "../../assets/css/home/DemandApproval.css";
</style>
<style>
#approval .goodsList .cell.el-tooltip {
  display: unset;
}
</style>



// WEBPACK FOOTER //
// src/components/home/DemandApproval.vue